'use client'
import type React from 'react'
import { forwardRef } from 'react'
import { Flex } from '../flex'
import { Typography } from '../typography'

interface BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Title */
  label: string
  /** description */
  description: string
  /** Label or Button */
  labelOnly?: boolean
  children?: React.ReactNode
}

const cx = (...args: (string | false | null | undefined)[]) => args.filter(Boolean).join(' ')

/**
 * Badge
 */
export const Badge = forwardRef<HTMLDivElement, BadgeProps>(
  (
    {
      label,
      description,
      labelOnly = true,
      children,
      className,
      onClick,
      onKeyDown,
      tabIndex,
      role,
      ...rest
    },
    ref
  ) => {
    return (
      <>
        <Flex align="center" gap="3">
          <div
            ref={ref}
            onClick={onClick}
            className={cx(
              'flex size-8 shrink-0 items-center justify-center rounded-full',
              className
            )}
            {...rest}
          >
            <span className="text-white">{label}</span>
          </div>
          <Typography>{description}</Typography>
        </Flex>
        {children}
      </>
    )
  }
)

Badge.displayName = 'Badge'
